
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'TNMHilarCholangiocarcinoma',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/TNMHilarCholangiocarcinoma.vue